import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import { InputTextField } from '@/components/UI/InputTextField';
import { PasswordField } from '@/components/UI/PasswordField';
import { RoundButton } from '@/components/UI/RoundButton';
import { CONTACT_EMAIL } from '@/helpers/constants';
import './index.scss';

const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    email: Yup.string()
      .email(t('login_form.val_invalid_email'))
      .required(t('login_form.val_email_required')),
    password: Yup.string().required(t('login_form.val_password_required')),
  });

const LoginForm = ({ error, onSubmit }) => {
  const existingEmail = useRef(sessionStorage.getItem('existingEmail'));
  const { t } = useTranslation('auth');

  useEffect(() => {
    return () => {
      sessionStorage.setItem('existingEmail', '');
    };
  }, []);

  return (
    <Formik
      onSubmit={onSubmit}
      validationSchema={VALIDATION_SCHEMA(t)}
      initialValues={{
        email: existingEmail.current ? existingEmail.current : '',
        password: '',
      }}
    >
      {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => (
        <form className="login-form" onSubmit={handleSubmit}>
          <h1 className="login-form__title f-500">{t('login_form.title')}</h1>
          <InputTextField
            label={t('login_form.email_label', { required: '*' })}
            name="email"
            value={values.email}
            onChange={e => setFieldValue('email', e.target.value.trim())}
            onClear={() => setFieldValue('email', '')}
            className="login-form__email"
            error={errors.email && touched.email && errors.email}
          />
          <PasswordField
            value={values.password}
            label={t('login_form.password_label', { required: '*' })}
            onChange={handleChange}
            onClear={() => setFieldValue('password', '')}
            error={errors.password && touched.password && errors.password}
            className="login-form__password"
          />
          {error && typeof error === 'string' && error.includes(CONTACT_EMAIL) && (
            <p className="login-form__error f-16 f-500">
              {t('login_form.suspicious_activity')} <br />
              {t('login_form.contact_us')} <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </p>
          )}
          <RoundButton
            label={t('login_form.login_button')}
            className="login-form__submit"
            type="submit"
            onSubmit={handleSubmit}
            fillBackground
            fullWidth
            withArrow
          />
          <Link to="/forgot-password" className="login-form__link">
            {t('login_form.forgot_password')}
          </Link>
          {/*<div className="login-form__bottom">*/}
          {/*  <span>{t('login_form.not_a_member')}</span>*/}
          {/*  <RoundLink label={t('login_form.sign_up')} path="/sign-up" />*/}
          {/*</div>*/}
        </form>
      )}
    </Formik>
  );
};

export default LoginForm;
